(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('OfficePhoneDeleteController',OfficePhoneDeleteController);

    OfficePhoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'OfficePhone'];

    function OfficePhoneDeleteController($uibModalInstance, entity, OfficePhone) {
        var vm = this;

        vm.officePhone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OfficePhone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
